import { Price } from '@flecto/utils/src/Number'

/**
 * Converts a value in cents to a decimal value.
 * @param value - The value in cents.
 * @returns The decimal value.
 */
export const valueFromCents = (value: number) => {
  return new Price(value)
}

const NumberHelper = {
  valueFromCents,
}

export default NumberHelper
